/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import cn from 'classnames';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { PageHeader } from '../../../../app/components/PageHeader';
import CardComponent from '../../../containers/App/Components/Card/Card';
import LoadingCard from '../../../containers/App/Components/LoadingCard/LoadingCard';
import PaginationComponent from '../../../containers/App/Components/Pagination/Pagination';
import { ChevronRight, Home, Sort } from '../../../components/Icon';
import CheckboxComponent from '../../../containers/App/Components/Checkbox/Checkbox';
import { TransportOrderSearch } from '../components/Search';
import { RegplateLabel } from '../../Vehicles/components/RegplateLabel';
import { VehicleStatusLabel } from '../../Vehicles/components/VehicleStatusLabel';
import { VBox } from '../../../components/Box';
import { getDate } from '../../Vehicles/helpers';
import { WithVehicle } from '../../Vehicles/components/WithVehicle';
import LoadingFilters from '../../../containers/App/Components/LoadingFilters/LoadingFilters';

import {
  addTransportOrderToBulkActionsList,
  applyTransportOrderFilters,
  changeTransportOrderFilter,
  removeTransportOrderFromBulkActionsList,
  setTransportOrdersSort,
} from '../actions';
import { setScrollPosition } from '../../Actions/actions';
import { toggleNotification } from '../../Companies/actions';

import {
  selectSeparateListTransportOrderCount,
  selectSeparateListTransportOrderPaginator,
  selectTransportOrderCount,
  selectTransportOrderFilter,
  selectTransportOrderPaginator,
  selectTransportOrders,
  selectTransportOrdersBulkActionsList,
  selectTransportOrdersSeparateList,
} from '../selectors';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_TRANSPORT_ORDERS, SET_TRANSPORT_ORDERS_SORT } from '../constants';
import s from './overview.module.css';
import { BulkActionsTransportOrderCard } from './BulkActions/BulkActionsCard';
import { transportOrdersSearch } from './../actions';
import { Button } from '../../../components/Buttons';
import { TransportOrderCreateModal } from '../components/createTransportOrder';
import ButtonComponent from '../../../containers/App/Components/Button/Button';

import MapWithMarkers from '../components/TransportMaps';

dayjs.extend(customParseFormat);

const STATE = {
  sort: null,
  sort_direction: 'down',
  isShowAddModal: false,
  isShowMore: true,
  currentPage: 0,
  localPaginator: {
    limit: 200,
    offset: 0,
    itemsCount: 0,
  },
  filteredVehicles: [],
};

/* eslint-disable react/prefer-stateless-function */
class TransportOrdersOverviewMapsComp extends BaseComponent {
  constructor(props) {
    super(props, STATE);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  get transportOrders() {
    if (this.props.weblogin && Array.isArray(this.state.filteredTransportOrders)) {
      return this.state.filteredTransportOrders;
    }

    return this.props.weblogin ? this.props.webloginVehicles : this.state.filteredTransportOrders;
  }

  getTypesTosort(type) {
    let types = {
      info: 'model_name',
    };

    return types[type] || type;
  }

  sortOn(field) {
    if (this.noSortingTypes?.includes(field)) {
      return;
    }

    let direction = 'none';
    let sortType;

    switch (field) {
      case 'info': {
        sortType = 'model_name';
        break;
      }

      default:
        sortType = field;
    }

    let order;
    if (this.props.filter?.sortType == sortType) {
      if (!this.props.filter?.order) order = 'asc';
      if (this.props.filter?.order == 'asc') order = 'desc';
    } else {
      order = 'asc';
    }
    this.setState({ direction: !order ? 'none' : order == 'asc' ? 'up' : 'down' });
    order ? this.props.setSort(sortType, order) : this.props.setSort('', '');
  }

  selectPage = newPage => {
    const newOffset = newPage * this.props.paginator?.limit ?? 0;
    this.props.setScrollPosition(null);

    this.setState(
      prev => ({
        currentPage: newPage,
      }),
      this.props.changeFilter('offset', newOffset),
    );
  };

  toggleDiv = () => {
    this.setState(prevState => ({
      isShowMore: !prevState.isShowMore,
    }));
  };

  onSelectTransportOrder = (e, transportOrder) => {
    e.stopPropagation();

    if (this.isSelectedTransportOrder(transportOrder?.id)) {
      return this.props.removeTransportOrderFromBulkActionsList(transportOrder?.id);
    }
    return this.props.addTransportOrderToBulkActionsList(transportOrder);
  };

  isSelectedTransportOrder = transportOrderId => {
    return this.props.bulkActionsList?.filter(item => item?.id === transportOrderId)?.length === 1;
  };

  onSelectAll(e, transportOrders) {
    e.stopPropagation();
    return transportOrders?.filter(transportOrder => this.props.addTransportOrderToBulkActionsList(transportOrder));
  }

  onRemoveAll(e, transportOrders) {
    e.stopPropagation();
    return transportOrders?.filter(transportOrder => this.props.removeTransportOrderFromBulkActionsList(transportOrder?.id));
  }

  render() {
    // Render PageHeader if work exists
    if (this.props.work) {
      return (
        <>
          <PageHeader
            title={
              <>
                <Home />
                {this.lbl('transport_order.overview.title')}
                {this.props.count !== null ? <span className="label number">{this.props.count}</span> : null}
              </>
            }
            breadCrumbs={
              <>
                <a href="/">Vindat</a>
                <ChevronRight />
                {this.lbl('transport_order.overview.title')}
              </>
            }
          />
          <LoadingFilters />
        </>
      );
    }

    const { transportOrders } = this.props;

    return (
      <div className="container-fluid p-0">
      
        {window.innerWidth >= 1024 && this.props.count !== (null || 0) && (
          <>
            <MapWithMarkers
              weblogin={this.props.weblogin}
              isSelectedTransportOrder={this.isSelectedTransportOrder}
              onSelectTransportOrder={this.onSelectTransportOrder}
              transportOrders={transportOrders}
            />
          </>
        )}
      </div>
    );
  }
}

TransportOrdersOverviewMapsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    transportOrders: ownProps.separateList ? selectTransportOrdersSeparateList() : selectTransportOrders(),
    filter: selectTransportOrderFilter(),
    count: ownProps.separateList ? selectSeparateListTransportOrderCount() : selectTransportOrderCount(),
    paginator: ownProps.separateList ? selectSeparateListTransportOrderPaginator() : selectTransportOrderPaginator(),
    bulkActionsList: selectTransportOrdersBulkActionsList(),

    work: selectWorks([REQUEST_TRANSPORT_ORDERS]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch: () => {
      dispatch(changeTransportOrderFilter('searchString', ''));
    },
    changeFilter: (name, value) => {
      dispatch(changeTransportOrderFilter(name, value, { separateList: ownProps.separateList ?? null }));
    },

    addTransportOrderToBulkActionsList(transportOrder) {
      dispatch(addTransportOrderToBulkActionsList(transportOrder));
    },
    removeTransportOrderFromBulkActionsList(transportOrderId) {
      dispatch(removeTransportOrderFromBulkActionsList(transportOrderId));
    },

    setScrollPosition(pos) {
      dispatch(setScrollPosition(pos));
    },
    toggleNotification() {
      dispatch(toggleNotification('0'));
    },
    async setSort(type, order) {
      try {
        const result = await dispatch(setTransportOrdersSort(type, order));
        if (result?.type == SET_TRANSPORT_ORDERS_SORT) {
          dispatch(applyTransportOrderFilters());
        }
      } catch (e) {}
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransportOrdersOverviewMaps = compose(withConnect, withRouter)(TransportOrdersOverviewMapsComp);
